import Splide from '@splidejs/splide';

(function () {
  'use strict';

  const classes = {
    stageContentWrapperActive: 'stage__content__wrapper--active'
  };

  const selectors = {
    splide: '.js-stage-slider',
    contentWrapper: '.stage__content__wrapper',
    nextButton: '.stage__arrow__next',
    previousButton: '.stage__arrow__prev'
  };

  const onMoveUpdateDescriptionContent = index => {
    const contentWrappers = document.querySelectorAll(selectors.contentWrapper);

    contentWrappers.forEach(wrapper => {
      wrapper.classList.remove(classes.stageContentWrapperActive);
    });

    const activeContent = contentWrappers[index];
    if (activeContent) {
      activeContent.classList.add(classes.stageContentWrapperActive);
    }
  };

  const init = () => {
    const splide = document.querySelector(selectors.splide);
    const nextButton = document.querySelector(selectors.nextButton);
    const previousButton = document.querySelector(selectors.previousButton);

    if (splide instanceof HTMLElement) {
      const homeSlider = new Splide(splide, {
        type: 'loop',
        perPage: 1,
        width: '100%',
        height: '100%',
        gap: 10,
        focus: 'center',
        breakpoints: {
          1024: {
            fixedHeight: '345px',
          },
          480: {
            fixedHeight: '220px'
          }
        },
        pagination: false,
        arrows: false
      }).mount();

      homeSlider.on('moved', index => {
        onMoveUpdateDescriptionContent(index);
      });

      if (previousButton instanceof HTMLElement) {
        previousButton.addEventListener('click', () => {
          homeSlider.go('<')
        })
      }

      if (nextButton instanceof HTMLElement) {
        nextButton.addEventListener('click', () => {
          homeSlider.go('>');
        });
      }
    }
  };

  window.addEventListener('load', init);
})();
